import React from "react";

export function RaiseApp({ color, height = 32, width = 32 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 44 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.6094 23.0885L37.75 25.0104L32.75 15.4479L36.6562 13.4947C36.9465 13.3468 37.2836 13.3196 37.5938 13.4191C37.9041 13.5186 38.1624 13.7368 38.3125 14.026L42.1562 21.3854C42.2342 21.5327 42.2819 21.6941 42.2965 21.8601C42.3112 22.0261 42.2925 22.1934 42.2415 22.3521C42.1906 22.5108 42.1084 22.6577 41.9998 22.7842C41.8913 22.9106 41.7585 23.0141 41.6094 23.0885V23.0885Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.25 24.854L6.3906 22.9165C6.242 22.8437 6.10956 22.7417 6.00116 22.6167C5.89276 22.4916 5.8106 22.3461 5.75959 22.1886C5.70857 22.0312 5.68973 21.8651 5.70418 21.7003C5.71864 21.5354 5.76609 21.3751 5.84373 21.229L9.68748 13.8696C9.83784 13.5806 10.0951 13.3617 10.4045 13.2596C10.7138 13.1574 11.0508 13.1801 11.3437 13.3227L15.25 15.2759L10.25 24.854Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.75 25.0102L35.25 27.9477L29.5 33.6977C29.3433 33.8442 29.1534 33.9506 28.9466 34.0078C28.7398 34.0649 28.5222 34.0711 28.3125 34.0258L19.25 31.7602C19.0845 31.714 18.9302 31.6343 18.7969 31.5258L10.25 24.8539"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.25 27.9478L28.375 22.9478L26.375 24.4478C25.5085 25.0945 24.4562 25.4439 23.375 25.4439C22.2938 25.4439 21.2415 25.0945 20.375 24.4478L19.5313 23.8072C19.3886 23.6987 19.2706 23.5612 19.185 23.4037C19.0995 23.2462 19.0484 23.0723 19.0351 22.8936C19.0218 22.7148 19.0466 22.5353 19.1079 22.3669C19.1692 22.1984 19.2656 22.045 19.3906 21.9166L25.5156 15.8072C25.6307 15.6927 25.7672 15.602 25.9173 15.5404C26.0675 15.4787 26.2283 15.4473 26.3906 15.4478H32.75"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3438 15.2759L23.3594 12.9322C23.6442 12.8505 23.9488 12.8726 24.2187 12.9947L29.625 15.4478"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5 37.3228L16.7969 36.1353C16.6052 36.092 16.4278 36.0005 16.2812 35.8696L12.75 32.8071"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
